export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
  };
}
